export default __webpack_public_path__ + "static/media/DNo.31-3.e1eee577.jpg";